import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { COUNTRIES } from '@/lib/i18n';

/**
 * Country picker (single-select). ISO-2 code as value.
 * Props:
 *   value: string (ISO-2)
 *   onChange: (code) => void
 *   placeholder?: string
 *   includeAll?: boolean (adds an "All countries" option with value "")
 *   testId?: string
 */
export const CountrySelect = ({ value, onChange, placeholder = 'Select country', includeAll = false, testId = 'country-select' }) => {
  // Select uses "" as empty; we use "_all" for the all-countries option to avoid conflict
  const current = includeAll && !value ? '_all' : value || '';
  return (
    <Select value={current} onValueChange={(v) => onChange(v === '_all' ? '' : v)}>
      <SelectTrigger data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-[300px]">
        {includeAll && (
          <SelectItem value="_all" data-testid={`${testId}-all`}>
            🌍 All countries
          </SelectItem>
        )}
        {COUNTRIES.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`${testId}-${c.code}`}>
            {c.flag} {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CountrySelect;
